import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  APP_SETTING_DELETE_DEV_API_KEY_BEGIN,
  APP_SETTING_DELETE_DEV_API_KEY_SUCCESS,
  APP_SETTING_DELETE_DEV_API_KEY_FAILURE,
  APP_SETTING_DELETE_DEV_API_KEY_DISMISS_ERROR,
} from './constants';

export function deleteDevApiKey(args = {}) {
  const { projectId, version, keyId } = args;
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_DELETE_DEV_API_KEY_BEGIN,
    });

    const header = builderSurfaceJsonContentHeader(projectId);
    const url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/developer-apis/${projectId}/devApiKeys/${keyId}`;

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(url, header);
      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_DELETE_DEV_API_KEY_SUCCESS,
            data: { keyId },
          });
          toast.success('API Key deleted successfully!');
          resolve(res);
        },
        (err) => {
          const errMsg =
            err?.response?.data?.message || err?.message || 'Failed to delete API key';
          toast.error(errMsg);
          dispatch({
            type: APP_SETTING_DELETE_DEV_API_KEY_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteDevApiKeyError() {
  return {
    type: APP_SETTING_DELETE_DEV_API_KEY_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_DELETE_DEV_API_KEY_BEGIN:
      return {
        ...state,
        deleteDevApiKeyPending: true,
        deleteDevApiKeyError: null,
      };

    case APP_SETTING_DELETE_DEV_API_KEY_SUCCESS: {
      const { keyId } = action.data;
      const devApiKeys = (state.devApiKeys || []).filter(
        (k) => k._id !== keyId && k.uuid !== keyId,
      );
      return {
        ...state,
        deleteDevApiKeyPending: false,
        deleteDevApiKeyError: null,
        devApiKeys,
      };
    }

    case APP_SETTING_DELETE_DEV_API_KEY_FAILURE:
      return {
        ...state,
        deleteDevApiKeyPending: false,
        deleteDevApiKeyError: action.data.error,
      };

    case APP_SETTING_DELETE_DEV_API_KEY_DISMISS_ERROR:
      return {
        ...state,
        deleteDevApiKeyError: null,
      };

    default:
      return state;
  }
}
